import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import Alert from "@mui/material/Alert";
import { Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import SubTitle from "../../components/SubTitle";

import { doService } from "../../services/ServiceHelper";
import {
  getTeacherActivities,
  updateActivityLocations,
} from "../../services/ActivityService";
import {
  getLocations,
} from "../../services/SchoolService";
import { showError, showSuccess } from "../../components/ATPDialogs";

const BulkChangeLocation = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);

  const [_activities, setActivities] = useState([]);
  const [_locations, setLocations] = React.useState([]);

  const [_selectedActivityEid, setSelectedActivityEid] = useState("XX");
  const [_selectedLocationEid, setSelectedLocationEid] = useState("XX");

  useEffect(() => {
    initActivities();
    initLocations();
  }, []);

  const initLocations = () => {
    doService(getLocations(_school, _jwt), (result) => {
      setLocations(result.data);
    });
  };

  const initActivities = () => {
    doService(getTeacherActivities(_school, _jwt), (result) => {
      setActivities(result.data);
    });
  };

  const handleClickUpdate = () => {
    if (_selectedActivityEid === "XX") {
      showError("Unable to Update", "Please select an Activity.");
      return;
    }
    if (_selectedLocationEid === "XX") {
      showError("Unable to Update", "Please select a new Location.");
      return;
    }

    setShowProgress(true);
    doService(
      updateActivityLocations(
        _school,
        _jwt,
        _selectedActivityEid,
        _selectedLocationEid
      ),
      (results) => {
        showSuccess("Activity Dates Updated!");
      },
      null,
      null,
      () => setShowProgress(false)
    );
  };

  const handleChangeActivity = (event) =>
    setSelectedActivityEid(event.target.value);

  const handleChangeLocation = (event) =>
    setSelectedLocationEid(event.target.value);

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Bulk Change Location" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Alert severity="info" sx={{ mt: 1 }}>
          Update your activity dates' locations by selecting the activity and
          new location, and clicking the Update Activity Dates button.
        </Alert>

        <Box sx={{ boxShadow: 1, p: 1, mt: 2 }}>
          <SubTitle text="Search by Date Range" />
          <br />
          <Grid container spacing={1} sx={{ pt: 1 }}>
            <Grid sx={{ pt: "0.5em !important", mb: 1 }} item xs={6} md={6}>
              <InputLabel>1. Select Activity:</InputLabel>
              <Select
                sx={{ mt: 1 }}
                fullWidth
                size="small"
                onChange={handleChangeActivity}
                value={_selectedActivityEid}
              >
                <MenuItem key="XX" value="XX">
                  -- SELECT --
                </MenuItem>
                {_activities.map((activity) => (
                  <MenuItem key={activity.eid} value={activity.eid}>
                    {activity.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid sx={{ pt: "0.5em !important", mb: 1 }} item xs={6} md={6}>
              <InputLabel>2. Select New Location:</InputLabel>
              <Select
                sx={{ mt: 1 }}
                fullWidth
                size="small"
                onChange={handleChangeLocation}
                value={_selectedLocationEid}
              >
                <MenuItem key="XX" value="XX">
                  -- SELECT --
                </MenuItem>
                {_locations.map((location) => (
                  <MenuItem key={location.eid} value={location.eid}>
                    {location.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>

          <Button
            sx={{ mt: 1 }}
            variant="contained"
            fullWidth
            onClick={handleClickUpdate}
          >
            Update Activity Dates
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default BulkChangeLocation;
